import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSingleData } from "../Hooks/index";
import Loading from "../../../Common/Loading";
import ClassDescriptions from "../Components/SingleComponents/ClassDescriptions";
import ClassInfo from "../Components/SingleComponents/ClassInfo";
import OrganizerInfo from "../Components/SingleComponents/OrganizerInfo";
import TeachersInfo from "../Components/SingleComponents/TeachersInfo";
import { Helmet } from "react-helmet";
function Single() {
  const { slug } = useParams();
  const { Data, loading, getData } = useSingleData();
  useEffect(() => {
    getData(slug);
  }, []);
  const renderSlug = () => {
    let slugList = slug && slug.split("-");
    let res = "";
    slugList &&
      slugList.map(ch => {
        if (!(typeof ch == "number")) {
          res += " " + ch;
        }
      });
    return res;
  };
  return (
    <>
      <Helmet>
        <title>نیکوتن | {renderSlug()} </title>
        <meta name="description" content={renderSlug()} />
        <link
          rel="canonical"
          href={window.origin + `/Classes/Single/${slug}`}
        />
      </Helmet>
      {loading ? (
        <Loading count={1} col={12} height={300} />
      ) : (
        <div className="container mt-4">
          <div className="row justify-content-between">
            <div className="col-md-7">
              <div className="d-flex flex-column">
                <ClassInfo data={Data.Items} />
                <ClassDescriptions data={Data.Items} />
              </div>
            </div>
            <div className="col-md-5">
              <div className="d-flex flex-column">
                <TeachersInfo data={Data.Items} />
                <OrganizerInfo data={Data.Items} />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Single;
